/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FacultyDTO
 */
export interface FacultyDTO {
    /**
     * 
     * @type {string}
     * @memberof FacultyDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof FacultyDTO
     */
    readonly name?: string | null;
}

export function FacultyDTOFromJSON(json: any): FacultyDTO {
    return FacultyDTOFromJSONTyped(json, false);
}

export function FacultyDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): FacultyDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function FacultyDTOToJSON(value?: FacultyDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
    };
}

